<template>
  <div>
    <v-menu offset-y min-width="200">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text rounded height="44" class="px-2" v-bind="attrs" v-on="on" :aria-label="'حساب ' + ($store.state.userName || '')">
          <v-avatar size="32" color="primary">
            <v-icon dark small>mdi-account</v-icon>
          </v-avatar>
          <span class="user-menu__name">{{ $store.state.userName }}</span>
          <v-icon small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense class="user-menu__list">
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon color="error">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>تسجيل خروج</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  methods: {
    logout() {
      this.$store.commit("setUserData", null);
      this.$router.push("/login");
    },
  },
};
</script>
